interface NestedStatusProps {
  isAccountCountryMY: boolean;
  isInternalAccount: boolean;
}

export const GET_NESTED_STATUS_OPTIONS = ({
  isAccountCountryMY,
  isInternalAccount
}: NestedStatusProps) => [
  {
    name: "Status ongoing",
    isExpand: false,
    children: [
      {
        name: "BKD",
        value: "BKD"
      },
      {
        name: "PUP",
        value: "PUP"
      },
      {
        name: "STI-SC",
        value: "STI-SC"
      },
      {
        name: "STI",
        value: "STI"
      },
      {
        name: "BAGGING",
        value: "BAGGING"
      },
      {
        name: "CARGO PLANE",
        value: "CARGO PLANE"
      },
      {
        name: "CARGO TRUCK",
        value: "CARGO TRUCK"
      },
      {
        name: "CARGO TRAIN",
        value: "CARGO TRAIN"
      },
      {
        name: "CARGO SHIP",
        value: "CARGO SHIP"
      },
      {
        name: "PICKUP TRUCK",
        value: "PICKUP TRUCK"
      },
      {
        name: "DROPOFF TRUCK",
        value: "DROPOFF TRUCK"
      },
      {
        name: "TRANSIT",
        value: "TRANSIT"
      },
      {
        name: "STI-DEST",
        value: "STI-DEST"
      },
      {
        name: "HND",
        value: "HND"
      },
      {
        name: "DEL",
        value: "DEL"
      },
      {
        name: "STT REMOVE",
        value: "STT REMOVE"
      },
      {
        name: "STT ADJUSTED",
        value: "STT ADJUSTED"
      },
      {
        name: "HAL",
        value: "HAL"
      },
      {
        name: "ODA",
        value: "ODA"
      },
      {
        name: "OCC",
        value: "OCC"
      },
      {
        name: "STO-SC",
        value: "STO-SC"
      },
      {
        name: "OCC-HAL",
        value: "OCC-HAL"
      },
      {
        name: "OCC-EXP",
        value: "OCC-EXP"
      },
      {
        name: "OCC-IMP",
        value: "OCC-IMP"
      },
      {
        name: "INTHND",
        value: "INTHND"
      },
      {
        name: "INT-STI",
        value: "INT-STI"
      },
      {
        name: "IN-HUB",
        value: "IN-HUB"
      },
      {
        name: "OUT-HUB",
        value: "OUT-HUB"
      },
      {
        name: "KONDISPATCH",
        value: "KONDISPATCH"
      },
      {
        name: "STLDISPATCH",
        value: "STLDISPATCH"
      },
      ...(isAccountCountryMY || isInternalAccount
        ? [
            {
              name: "RCC-IMP",
              value: "RCC-IMP"
            }
          ]
        : [])
    ]
  },
  {
    name: "Status bermasalah",
    isExpand: false,
    children: [
      {
        name: "DEX",
        value: "DEX"
      },
      {
        name: "SCRAP",
        value: "SCRAP"
      },
      {
        name: "SHORTLAND",
        value: "SHORTLAND"
      },
      {
        name: "MIS-ROUTE",
        value: "MIS-ROUTE"
      },
      {
        name: "CODREJ",
        value: "CODREJ"
      },
      {
        name: "MISSING",
        value: "MISSING"
      },
      {
        name: "DAMAGE",
        value: "DAMAGE"
      },
      {
        name: "NOT RECEIVED",
        value: "NOT RECEIVED"
      },
      {
        name: "MISBOOKING",
        value: "MISBOOKING"
      },
      {
        name: "REJECTED",
        value: "REJECTED"
      }
    ]
  },
  {
    name: "Status final",
    isExpand: false,
    children: [
      {
        name: "POD",
        value: "POD"
      },
      {
        name: "CNX",
        value: "CNX"
      },
      {
        name: "RTS",
        value: "RTS"
      },
      {
        name: "CLAIM",
        value: "CLAIM"
      },
      {
        name: "CI",
        value: "CI"
      },
      {
        name: "RTSHQ",
        value: "RTSHQ"
      },
      {
        name: "STT ADJUSTED POD",
        value: "STT ADJUSTED POD"
      },
      {
        name: "REROUTE",
        value: "REROUTE"
      },
      {
        name: "CNXCD",
        value: "CNXCD"
      },
      {
        name: "HALCD",
        value: "HALCD"
      },
      {
        name: "SCRAPCD",
        value: "SCRAPCD"
      }
    ]
  }
];
